import React from 'react';
import { Datagrid, List, TextField, TextInput } from 'react-admin';
import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { RecordRowActions } from '../components/record/RecordRowActions.tsx';
import { ImportEmpty, ListActionsWithImport } from '../data-import/ImportButton.tsx';

const CompanyList: React.FC = () => {
  const CompanyFilters = [<TextInput key="search" label="Search" source="q" alwaysOn />];

  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <Typography color="text.primary">Companies</Typography>
      </Breadcrumbs>
      <List
        filters={CompanyFilters}
        actions={<ListActionsWithImport kind="companies" />}
        empty={<ImportEmpty kind="companies" />}
      >
        <Datagrid rowClick="show" bulkActionButtons={false}>
          <TextField source="id" />
          <TextField source="name" />
          <RecordRowActions />
        </Datagrid>
      </List>
    </Container>
  );
};

export default CompanyList;
